"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Easings are taken from: https://gist.github.com/gre/1650294
 */
var EASINGS = {
  easeInOutCubic: function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }
};
/**
 * This class is used for creating an animation with an easing.
 */

var EasingAnimation = /*#__PURE__*/function () {
  /**
   * Class constructor.
   */
  function EasingAnimation() {
    _classCallCheck(this, EasingAnimation);

    this.startValue = 0; // Start value

    this.endValue = 20; // End value

    this.callback = function () {}; // Callback to be called between each iteration


    this.easingType = 'easeInOutCubic'; // Type of easing

    this.animationDuration = 500; // Animation duration in ms

    this.frameInterval = 20; // Min time between frames in ms

    this._value = 0;
    this._animationStartTime = 0;
    this._lastFrame = 0;
    this._animationFrameId = null;
    this._events = {
      frame: [],
      end: []
    };
  }
  /**
   * Adds an event listener.
   *
   * @param {string} eventName Event name (frame, end).
   * @param {Function} callback Callback to be called.
   */


  _createClass(EasingAnimation, [{
    key: "on",
    value: function on(eventName, callback) {
      this._events[eventName].push(callback);
    }
    /**
     * Removes an event listener.
     *
     * @param {string} eventName Event name (frame, end).
     * @param {Function} callback Callback to be called.
     */

  }, {
    key: "off",
    value: function off(eventName, callback) {
      var index = this._events[eventName].indexOf(callback);

      if (index > -1) {
        this._events[eventName].splice(index, 1);
      }
    }
    /**
     * Triggers an event.
     *
     * @param {string} eventName Event name (frame, end).
     * @param {string} data Data to send to the callback.
     */

  }, {
    key: "trigger",
    value: function trigger(eventName, data) {
      var _iterator = _createForOfIteratorHelper(this._events[eventName]),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var callback = _step.value;
          callback(data);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Starts the animation.
     */

  }, {
    key: "start",
    value: function start() {
      cancelAnimationFrame(this._animationFrameId);
      this._value = this.startValue;
      this._animationStartTime = performance.now();
      this._animationFrameId = requestAnimationFrame(this._animate.bind(this));
    }
    /**
     * Stops the animation.
     */

  }, {
    key: "stop",
    value: function stop() {
      cancelAnimationFrame(this._animationFrameId);
      this.trigger('end', this._value);
    }
    /**
     * Calculate eased value, from start value to end value, based on percent of progress.
     *
     * @param {number} startValue Initial value for easing.
     * @param {number} endValue Final value for easing.
     * @param {number} progress Progress of animation [0 to 1].
     * @returns {number} New value based on easing and progress.
     */

  }, {
    key: "_calculateValue",
    value: function _calculateValue(startValue, endValue, progress) {
      var newValue = 0;

      if (startValue < endValue) {
        newValue = startValue + (endValue - startValue) * EASINGS[this.easingType](progress);
      } else {
        newValue = startValue - (startValue - endValue) * EASINGS[this.easingType](progress);
      }

      if (startValue === Math.round(startValue) && endValue === Math.round(endValue)) {
        newValue = Math.round(newValue);
      }

      if (progress > 1) {
        newValue = endValue;
      }

      return newValue;
    }
    /**
     * Animation frame - callback passed to rAF.
     *
     * @param {DOMHighResTimeStamp} now Current time when rAF start to fire callback.
     */

  }, {
    key: "_animate",
    value: function _animate(now) {
      var animationElapsedTime = now - this._animationStartTime;
      var frameElapsedTime = now - this._lastFrame;
      this._value = this._calculateValue(this.startValue, this.endValue, animationElapsedTime / this.animationDuration);

      if (animationElapsedTime > this.animationDuration) {
        this.trigger('frame', this.endValue);
        this.stop();
      } else {
        this._animationFrameId = requestAnimationFrame(this._animate.bind(this));

        if (frameElapsedTime > this.frameInterval) {
          this.trigger('frame', this._value);
          this._lastFrame = now - frameElapsedTime % this.frameInterval;
        }
      }
    }
  }]);

  return EasingAnimation;
}();

exports.default = EasingAnimation;